import { Button, Grid, styled } from "@mui/material";

const ButtonOperationStyled = styled(Button)<{ entered: boolean }>(( props ) => (
    {
      backgroundColor: "rgb(254,241,73,.1)",
      borderColor: props.entered ? "#fff" : "rgba(255, 241, 73, 0.5)"
    }
  ))

  interface ButtonOperationProps {
    operation: string;
    enterOperation: (operation: string) => void;
    enteredOperation: string;
  }

export const ButtonOperation: React.FC<ButtonOperationProps> = ({ operation, enterOperation, enteredOperation }) => {
    return (
      <Grid item xs={ 3 }>
        <ButtonOperationStyled 
        fullWidth 
        variant="outlined" 
        entered={ enteredOperation == operation } 
        onClick={
          () => enterOperation(operation)
        }>
          { operation }
        </ButtonOperationStyled>
      </Grid>
    )
  }